import React from 'react';
import { useTranslation } from '../../context/TranslationContext';
import './LanguageSelector.css';

const LanguageSelector = ({ compact = false }) => {
  const { currentLanguage, languages, changeLanguage, loading } = useTranslation();

  console.log('LanguageSelector - Current Language:', currentLanguage);
  console.log('LanguageSelector - Available Languages:', languages);

  if (loading || !languages || languages.length === 0) {
    return null;
  }

  const handleLanguageChange = async (langCode) => {
    console.log('LanguageSelector - Changing from', currentLanguage, 'to', langCode);
    if (langCode !== currentLanguage) {
      await changeLanguage(langCode);
    }
  };

  if (compact) {
    return (
      <div className="language-selector-compact">
        <select 
          value={currentLanguage} 
          onChange={(e) => handleLanguageChange(e.target.value)}
          className="language-select"
        >
          {languages.map((lang) => (
            <option key={lang.language_code} value={lang.language_code}>
              {lang.flag_icon} {lang.language_code.toUpperCase()}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div className="language-selector">
      {languages.map((lang) => (
        <button
          key={lang.language_code}
          onClick={() => handleLanguageChange(lang.language_code)}
          className={`language-btn ${currentLanguage === lang.language_code ? 'active' : ''}`}
          title={lang.language_name}
        >
          <span className="language-flag">{lang.flag_icon}</span>
          <span className="language-code">{lang.language_code.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;